/**
 * Global store for managing message input across views
 * Allows resources to be added as @mentions from any view
 */

import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface MessageInputState {
  pendingMentions: string[];
  
  // Actions
  addMentions: (mentions: string[]) => void;
  clearMentions: () => void;
  getPendingMentions: () => string[];
}

export const useMessageInputStore = create<MessageInputState>()(
  devtools(
    (set, get) => ({
      pendingMentions: [],
      
      addMentions: (mentions) => {
        set((state) => ({
          pendingMentions: [...state.pendingMentions, ...mentions]
        }), false, 'addMentions');
      },
      
      clearMentions: () => {
        set({ pendingMentions: [] }, false, 'clearMentions');
      },
      
      getPendingMentions: () => {
        return get().pendingMentions;
      }
    }),
    {
      name: 'message-input-store',
    }
  )
);